import { AgenciesReducer } from '@/store/agencies';
import { AuthReducer } from '@/store/auth';
import { CustomerReducer } from '@/store/customer';
import { FormsReducer } from '@/store/forms';
import { MatchedGrantsReducer } from '@/store/matchedGrants';
import { MatchedPFReducer } from '@/store/matchedPF';
import { SnackbarReducer } from '@/store/snackbar';
import { combineReducers, configureStore } from '@reduxjs/toolkit';
const rootReducer = combineReducers({
    agencies: AgenciesReducer,
    auth: AuthReducer,
    customer: CustomerReducer,
    forms: FormsReducer,
    matchedGrants: MatchedGrantsReducer,
    matchedPF: MatchedPFReducer,
    snackbar: SnackbarReducer,
});
export const store = configureStore({
    reducer: rootReducer,
    devTools: process.env.NODE_ENV !== 'production',
});
